// @flow
import React, {PureComponent} from "react";
import ReactDOM from "react-dom";
import Map from "./Map/Map";
import TopBar from "./TopBar/TopBar";
import {injectGlobal} from "styled-components";

import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Full} from "./AppStyle";
import GreyOverlay from "./GreyOverlay/GreyOverlay";
import Screen from "./Screen/Screen";
import Screens from "../Store/Views/screens";
import AppOperations from "../Store/Ducks/App/operations";
import type {CSSDirectionType} from "../Store/Ducks/App/utils";
import TokenDataSelectors from "../Store/Ducks/TokenData/selectors";

type ConnectedProps = {
    shouldShowMap: boolean,
    shouldShowOverlay: boolean,
    tokenDecrypted: boolean,
    onInitApp: (token: string, direction: CSSDirectionType) => void,
};

type OwnProps = {
    token: string;
};

class App extends PureComponent<OwnProps & ConnectedProps> {

    componentDidMount() {
        this.props.onInitApp(
            this.props.token,
            window.getComputedStyle(ReactDOM.findDOMNode(this.refs.container)).getPropertyValue("direction")
        );
    }

    render() {
        return (
            <Full ref={"container"}>
                <TopBar/>
                <Screen/>
                {this.props.tokenDecrypted && (<Map style={{display: this.props.shouldShowMap ? `block` : `none`}}/>)}
                {this.props.shouldShowOverlay && (<GreyOverlay/>)}
            </Full>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        shouldShowMap: Screens.shouldShowMap(state),
        shouldShowOverlay: Screens.shouldShowOverlay(state),
        tokenDecrypted: TokenDataSelectors.isTokenDecrypted(state),
    };
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            onInitApp: AppOperations.initApp,
        },
        dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(App);

injectGlobal`
    body {
        font-family: -apple-system, BlinkMacSystemFont, 'Roboto', system-ui, sans-serif;
        font-weight: 400;
        height: 100%;
        margin: 0;
        min-height: 100%;
        padding: 0;
        user-select: none;
        position: relative;
    }       
`;



// WEBPACK FOOTER //
// ./src/Components/App.js